import React, { createContext, useContext as useContextCore } from 'react'
import type { Colors } from '@ztechapps/common.hook'
import { ThemeProvider, ToastProvider } from '@ztechapps/webui.util'
import { ConfirmDialogProvider } from '@ztechapps/webui.modal'
import type { UseToggleSidebar } from './useToggleSidebar'
import { useToggleSidebar } from './useToggleSidebar'

export type AppContextType = {
  data?: any
  toggleSidebar: UseToggleSidebar
}

const context = createContext<AppContextType>({} as unknown as AppContextType)
const CoreProvider = context.Provider

const themeColors: Colors = {
  primary: '#6b2e81',
  primary75: '#6b3d7c',
  primary50: '#6e4d7a',
  primary25: '#9c7da8',
}

export const AppContextProvider = ({ children }) => {
  const toggleSidebar = useToggleSidebar()

  return (
    <CoreProvider value={{ toggleSidebar }}>
      <ToastProvider>
        <ThemeProvider routerType="react-router" colors={themeColors}>
          <ConfirmDialogProvider>{children}</ConfirmDialogProvider>
        </ThemeProvider>
      </ToastProvider>
    </CoreProvider>
  )
}

export const useAppContext = () => useContextCore(context)
